export default "__VITE_ASSET__f11ac1e9__"